// DO NOT EDIT MANUALLY
// This file was automatically generated by `scripts/MapboxStyles/process.ts`

import { MapboxStyleLayer } from '../types'

export const mapboxStyleGroupLayers_atlas_bicycleparking_areas: MapboxStyleLayer[] = [
  {
    type: 'fill',
    id: 'bicycleparking-areas',
    paint: {
      'fill-color': 'rgba(182, 36, 255, 0.49)',
    },
  },
]
